
import Toast from 'vux/src/components/toast/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'



export default {
name: "add-manager",
components: {
XButton,
XSwitch,
Checklist,
Toast,
Group,
XInput
},
data(){
return {
shopId: this.$route.params.shopId,
isSuperManager: false,
disableControl : false,
submitText: '提 交',
operatorName: null,
operatorPhone: null,
operatorPermissions: [],
permissionsList: [],
errFlag: false,
errMsg: '',
okFlag: false,
okMsg: '操作成功'
}
},
created(){
this.getPermissionsList()
},
methods: {
getPermissionsList() {
let _this = this;
let uri = '/system/shop/permissions';
let params = {
}
_this.axios.get(uri, params, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {
_this.permissionsList = response.data.data
}
}).catch(function (response) {
console.log(response);
});
},
processButton () {
this.submitText = '处理中'
this.disableControl = true
this.addManager()
},
reductionButton () {
this.submitText = '提 交'
this.disableControl = false
},
addManager(){
let shopId = this.shopId
let _this = this;
let uri = '/v1/shop/'+ shopId +'/manage/operator/add';
let params = {
'name': _this.operatorName,
'mobile': _this.operatorPhone,
'super': _this.isSuperManager,
'permissions': _this.operatorPermissions,
}
_this.axios.post(uri, params, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {
_this.successMsg(response.data.msg)
_this.goList()
} else {
_this.errorMsg(response.data.msg)
_this.reductionButton()
}
}).catch(function (response) {
_this.reductionButton()
_this.errorMsg(response.message)
});
},
goList(){
let shopId = this.$route.params.shopId
let path = '/shop/' + shopId + '/manage';
this.$router.push({
path: path
})
},
successMsg(msg){
this.okFlag = true
this.okMsg = msg
},
errorMsg(msg){
this.errFlag = true
this.errMsg = msg
}
}
}



// WEBPACK FOOTER //
// ./src/components/manage/ManagerAdd.vue